export const isEnabled = (config) => {
  if (!config) return false;
  if (typeof config === 'boolean') return config;
  if (typeof config === 'object' && 'enabled' in config) return !!config.enabled;
  return false;
};

export const isToolbarOptionEnabled = (config) => {
  return isEnabled(config) && typeof config === 'object' && config?.toolbar?.enabled === true;
};

export const isShortcutOptionEnabled = (config) => {
  return isEnabled(config) && typeof config === 'object' && config?.shortcuts?.enabled === true;
};

export const resolveObjectKeyLabel = (label) => {
  if (typeof label !== 'string') return null;
  return label
    .split('-')
    .map((part, index) => (index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)))
    .join('');
};
